// extracted by mini-css-extract-plugin
module.exports = {"w11cvrps":"w11cvrps","i1m7nudl":"i1m7nudl"};